import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCoachingV2RouteHandler } from 'Dashboard/components/CoachingPageV2/use-coaching-v2-route-handler';

// Constants
import QueryParamConstants from 'Shared/constants/QueryParams.constants';
import { Data } from './SelfReviewStartedModalData.constants';
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import NewFeatureCarouselModal from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal';

const SelfReviewStartedModal = () => {
  const { handleCoachingV2Redirect } = useCoachingV2RouteHandler();
  const [isOpen, toggleIsOpen] = useToggle(false);
  const { search } = useLocation();

  useEffect(() => {
    if (search.includes(QueryParamConstants.SELF_REVIEW_STARTED_MODAL)) {
      toggleIsOpen();
      handleCoachingV2Redirect({ pathname: PageUrls.COACHING_360 });
    }
  }, [search]);

  return <NewFeatureCarouselModal isOpen={isOpen} toggleIsOpen={toggleIsOpen} data={Data} />;
};

export default SelfReviewStartedModal;
